import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { UtilsService } from '@base/src/app/services/utils.service';
import { QRInputAutocomplete } from 'src/app/models/qr-input-autocomplete.model';

type InputTypes = string | number | undefined;

@Component({
  selector: 'qr-input-autocomplete',
  templateUrl: './input-autocomplete.component.html',
  styleUrls: ['./input-autocomplete.component.scss'],
})
export class InputAutocompleteComponent implements OnInit {
  @Input() config!: QRInputAutocomplete;
  @Input() isDisabled?: boolean = false;
  @Input() hasError?: boolean = false;
  @Input() value?: InputTypes;
  @Input() multilineAddressOptions = false;
  @Output() selectedChange: EventEmitter<string | undefined> = new EventEmitter<
    string | undefined
  >();
  @Output() blurChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() noResults: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() valueNoResults: EventEmitter<string> = new EventEmitter<string>();

  filteredOptions: string[] = [];
  isOptionsVisible: boolean = false;
  selectedOption: InputTypes;

  constructor(
    private readonly _eref: ElementRef,
    private readonly utils: UtilsService,
  ) {}

  @HostListener('document:click', ['$event', '$event.target'])
  onDocumentClicked(event: MouseEvent, targetElement: HTMLElement) {
    if (
      targetElement &&
      document.body.contains(targetElement) &&
      !this._eref.nativeElement.contains(targetElement)
    ) {
      this.isOptionsVisible = false;
    }
  }

  ngOnInit(): void {
    this.filteredOptions = this.config.options;
  }

  ngOnChanges(changes: any) {
    if (changes.config?.currentValue?.options) {
      this.filteredOptions = changes.config.currentValue.options;
    }
    if (changes.config?.currentValue?.value == 'clear') {
      this.selectedOption = undefined;
    } else {
      this.selectedOption = undefined;
      if (this.value) {
        this.selectedOption = this.value;
      }
    }
  }

  showOptions(): void {
    if (!this.isDisabled) {
      this.filteredOptions = this.config?.options ?? [];
      this.isOptionsVisible = true;
    }
  }

  inputChange(value: InputTypes): void {
    if (value != undefined) {
      let filtered = this.config.options.filter((o) =>
        this.utils.textNormalize(o)?.includes(this.utils.textNormalize(value)),
      );

      if (!filtered) filtered = [];

      this.noResults.emit(filtered.length == 0);
      if (filtered.length == 0) {
        this.valueNoResults?.emit(value?.toString() ?? '');
      }
      if (filtered) {
        this.filteredOptions = filtered;
      }
    } else {
      this.filteredOptions = this.config.options;
      this.selectedChange.emit(undefined);
      this.noResults.emit(false);
    }
  }

  select(option: string): void {
    this.isOptionsVisible = false;
    this.selectedOption = option;
    this.selectedChange.emit(this.selectedOption);
  }
}
